// extracted by mini-css-extract-plugin
module.exports = {"main":"Shops_main__2lZa_","breads":"Shops_breads__5N5Y5"};